import React, { ReactNode } from "react";
import { makeStyles, Box, Typography, colors } from "@material-ui/core";

const useItemStyles = makeStyles(
  (theme) => ({
    root: {
      "& span": {
        display: "block",
      },
    },

    title: {
      color: colors.grey[600],
      fontSize: 13,
    },

    subTitle: {
      marginTop: 2,
      fontSize: 16,
      fontWeight: theme.typography.fontWeightBold,
    },
  }),
  { name: "amount-detail-styles" }
);

interface AmountDetailProps {
  title: ReactNode;
  subTitle: ReactNode;
}

export function AmountDetail(props: AmountDetailProps) {
  const classes = useItemStyles(props);
  // Props
  const { title, subTitle } = props;

  return (
    <Box className={classes.root} mb={1} mt={1}>
      <Typography gutterBottom component="span" className={classes.title}>
        {title}
      </Typography>
      <Typography gutterBottom component="span" className={classes.subTitle}>
        {subTitle}
      </Typography>
    </Box>
  );
}
